import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class FunctionListenerService {
    private currentFunctionId: string = undefined;

    getCurrentFunctionId() {
        return this.currentFunctionId;
    }

    setCurrentFunctionId(funcId: string) {
        this.currentFunctionId = funcId;
    }
}
